import { useCallback, useState } from "react";

import type { DummyRoomNewItem_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { HeaderActions } from "./components";
import { ProductNewDummyRoomFormModelContextProvider } from "./context";
import { DialogConfirmContinueCreateRoom } from "../../../../_shared/ui/_components/dialog-confirm-continue-create-room";
import { useInitialized } from "../../model/usecase/new/use-init";
import { DummyRoomFormMain } from "../_shared/components/root";
import { dummyRoomCategoriesAndManagerStore } from "../_shared/store/categories";

type Props = {
	hotelID: string;
	serverModel: DummyRoomNewItem_EditPageQuery;
};

export const NewDummyRoomEditPresenter = ({ hotelID, serverModel }: Props) => {
	const [openDialogConfirmContinueCreateRoom, setOpenDialogConfirmContinueCreateRoom] = useState(false);
	const handleOpenChange = useCallback((input: boolean) => setOpenDialogConfirmContinueCreateRoom(input), []);
	const onOpenDialogConfirmContinueCreateRoom = useCallback(() => setOpenDialogConfirmContinueCreateRoom(true), []);

	const onCreateRoomSuccessCallback = useCallback(() => {
		onOpenDialogConfirmContinueCreateRoom();
	}, [onOpenDialogConfirmContinueCreateRoom]);

	const init = useInitialized({ onCreateRoomSuccessCallback, serverModel });

	const onTransitionToCreateRoom = useCallback(() => {
		/**
		 * @todo 再生成のロジックを実装し、ソフトナビゲーションで遷移する
		 */
		window.location.reload();
	}, []);

	const { categoryManagerStore } = dummyRoomCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const roomName = init.viewModel.name.value;

	return (
		<>
			<ProductNewDummyRoomFormModelContextProvider value={{ ...init }}>
				<FeatureIslandContainer>
					<FeatureIslandHeader title="新規ダミー部屋の作成" rightChildren={<HeaderActions />} />
					<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
						{/* @todo Layout の共通化が出来るまでは共通化しない */}
						<NameOfResourceBeingEdited resourceName={roomName} />

						<DummyRoomFormMain roomCategoriesAndManagerStore={dummyRoomCategoriesAndManagerStore} />
					</FeatureIslandMainWithCategory>
				</FeatureIslandContainer>
			</ProductNewDummyRoomFormModelContextProvider>

			<DialogConfirmContinueCreateRoom
				roomType="DUMMY"
				open={openDialogConfirmContinueCreateRoom}
				handleOpenChange={handleOpenChange}
				hotelID={hotelID}
				onTransitionToCreateRoom={onTransitionToCreateRoom}
			/>
		</>
	);
};

NewDummyRoomEditPresenter.displayName = "NewDummyRoomEditPresenter";
